import {
  clearSharedAuthCookie,
  clearSharedRefreshTokenCookie,
  getSharedAuthCookie,
} from "./Auth";

// Polling interval in milliseconds
const POLL_INTERVAL = 2000;

let previousToken: string | null = null;

/**
 * custom Event fired when there's a new valid token and we have dispatched an action to fetch user profile
 */
const userRefreshedEvent = new CustomEvent("bc-user-refreshed", {
  bubbles: true,
  composed: true,
});

/**
 * custom Event fired when the token is invalid or missing and the user has been logged out and their profile cleared
 */
const userLoggedOutEvent = new CustomEvent("bc-user-loggedout", {
  bubbles: true,
  composed: true,
});

/**
 * custom Event fired when the user is logged in
 */
const userLoggedInEvent = new CustomEvent("bc-user-loggedin", {
  bubbles: true,
  composed: true,
});

// Function to handle state based on cookie status
const checkForAuthStateChange = async () => {
  try {
    const url = new URL(window.location.href);
    if (url.searchParams.has("bcLogout")) {
      clearSharedAuthCookie();
      clearSharedRefreshTokenCookie();
      window.dispatchEvent(userLoggedOutEvent);
      url.searchParams.delete("bcLogout");
      window.location.replace(url.toString());
    }
  } catch (error) {
    console.warn("Error checking for logout auth state change", error);
  }
  const token = await getSharedAuthCookie();
  if (token && token !== previousToken) {
    // If there's a new valid token, dispatch an action to fetch user profile
    window.dispatchEvent(userRefreshedEvent);
  } else if (!token) {
    // If the token is invalid or missing, log the user out and clear the profile
    window.dispatchEvent(userLoggedOutEvent);
  } else if (token === previousToken) {
    // at this point the token exists and it's the same as the previous token, which means we should have a logged in user, so we dispatch an event to ensure this is the case
    window.dispatchEvent(userLoggedInEvent);
  }
  previousToken = token;
};
// Polling logic to check authentication status every X milliseconds
const startPollingAuthState = async () => {
  await checkForAuthStateChange();
  setInterval(checkForAuthStateChange, POLL_INTERVAL);
};

// Visibility change handler
const handleVisibilityChange = async () => {
  if (document.visibilityState === "visible") {
    // When the tab becomes visible, check the cookie status
    await checkForAuthStateChange();
  }
};

let isPolling = false;
export default () => {
  if (isPolling) {
    return;
  }
  isPolling = true;
  // Start polling when the app initializes
  startPollingAuthState();
  // Listen for visibility change events
  document.addEventListener("visibilitychange", handleVisibilityChange);
};
